import { useState, useEffect } from 'react';
import domainManagementService from '../services/domainManagementService';
import { TENANT_NAME } from 'constants/tenant-config';

export const useBranding = () => {
  const [branding, setBranding] = useState(
    domainManagementService.getBrandingConfig()
  );

  useEffect(() => {
    // Subscribe to branding changes if needed
    const unsubscribe = domainManagementService.subscribe?.((newBranding) => {
      setBranding(newBranding);
    });

    return unsubscribe;
  }, []);

  return {
    domainConfig: domainManagementService.getDomainConfig(),
    brandColor: domainManagementService.getBrandColor(),
    branding: domainManagementService.getBrandingConfig(),
    getTierName: (tier) =>
      domainManagementService.getTierName(
        tier,
        domainManagementService.getDomainConfig().domainKey
      ),
    getAgencyLogo: (tier) => {
      const tierList = domainManagementService.getTierAgencyPartnerList(
        domainManagementService.getDomainConfig().domainKey
      );
      return (
        tierList[
          `TIER_${tier?.toUpperCase()}_${
            domainManagementService.getDomainConfig().domainKey
          }`
        ]?.Logo ||
        tierList[
          `TIER_GENERAL_${domainManagementService.getDomainConfig().domainKey}`
        ]?.Logo
      );
    },
    isConquestTenant: domainManagementService.getDomainConfig().domainKey === TENANT_NAME.CONQUESTDSP,
    isTIBTenant: domainManagementService.getDomainConfig().domainKey === TENANT_NAME.TIB,
    isReachRightAdsTenant: domainManagementService.getDomainConfig().domainKey === TENANT_NAME.REACHRIGHTADS,
  };
};
